import { render, staticRenderFns } from "./YzDeleteConfirmationDialog.vue?vue&type=template&id=5d7c0bb9&scoped=true&lang=pug&"
import script from "./YzDeleteConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./YzDeleteConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./YzDeleteConfirmationDialog.vue?vue&type=style&index=0&id=5d7c0bb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c0bb9",
  null
  
)

export default component.exports